// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-quality[data-v-eda6bfbc] {
  margin-top: 8px;
}
.video-quality .video-quality-item[data-v-eda6bfbc] {
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
}
.terminals[data-v-eda6bfbc] {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  padding-left: 34px;
  font-size: 14px;
}
.terminals .items[data-v-eda6bfbc] {
  margin-top: -2px;
}
.terminals .item[data-v-eda6bfbc] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
}
.terminals .item[data-v-eda6bfbc] .custom-select-wrapper {
  width: 40%;
}
.terminals .item[data-v-eda6bfbc] .horizontal label.custom-radio {
  font-size: 14px;
}
.terminals .sipserver[data-v-eda6bfbc] {
  display: flex;
  flex-direction: row;
}
.terminals .sipserver .sipitem[data-v-eda6bfbc] {
  font-size: 14px;
  width: 48%;
}
.terminals .sipserver .sipitem[data-v-eda6bfbc] .custom-input-text {
  width: 100%;
  margin-right: 8px;
}
.terminals .sipserver .sipitem[data-v-eda6bfbc] .custom-input-text-placeholder {
  font-size: 14px;
}
.terminals .sipserver .sipitem[data-v-eda6bfbc] .custom-input-text-placeholder.up {
  font-size: 0.8em;
}
.terminals[data-v-eda6bfbc] .custom-select-wrapper {
  width: 48% !important;
  font-size: 14px;
}
.conf-modes-options[data-v-eda6bfbc] {
  flex-direction: column;
  align-items: flex-start;
  height: auto;
  margin-bottom: 0;
  display: flex;
}
.conf-modes-options .wrapper[data-v-eda6bfbc]:first-child {
  margin-top: 12px;
  margin-bottom: 2px;
}
.conf-modes-options .wrapper[data-v-eda6bfbc]:not(:first-child) {
  margin-top: 10px;
}
.conf-modes-options .wrapper[data-v-eda6bfbc] label.custom-checkbox {
  margin-bottom: auto;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/videomostSettings.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".video-quality[data-v-eda6bfbc] {\n  margin-top: 8px;\n}\n.video-quality .video-quality-item[data-v-eda6bfbc] {\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n}\n.terminals[data-v-eda6bfbc] {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 12px;\n  padding-left: 34px;\n  font-size: 14px;\n}\n.terminals .items[data-v-eda6bfbc] {\n  margin-top: -2px;\n}\n.terminals .item[data-v-eda6bfbc] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n}\n.terminals .item[data-v-eda6bfbc] .custom-select-wrapper {\n  width: 40%;\n}\n.terminals .item[data-v-eda6bfbc] .horizontal label.custom-radio {\n  font-size: 14px;\n}\n.terminals .sipserver[data-v-eda6bfbc] {\n  display: flex;\n  flex-direction: row;\n}\n.terminals .sipserver .sipitem[data-v-eda6bfbc] {\n  font-size: 14px;\n  width: 48%;\n}\n.terminals .sipserver .sipitem[data-v-eda6bfbc] .custom-input-text {\n  width: 100%;\n  margin-right: 8px;\n}\n.terminals .sipserver .sipitem[data-v-eda6bfbc] .custom-input-text-placeholder {\n  font-size: 14px;\n}\n.terminals .sipserver .sipitem[data-v-eda6bfbc] .custom-input-text-placeholder.up {\n  font-size: 0.8em;\n}\n.terminals[data-v-eda6bfbc] .custom-select-wrapper {\n  width: 48% !important;\n  font-size: 14px;\n}\n.conf-modes-options[data-v-eda6bfbc] {\n  flex-direction: column;\n  align-items: flex-start;\n  height: auto;\n  margin-bottom: 0;\n  display: flex;\n}\n.conf-modes-options .wrapper[data-v-eda6bfbc]:first-child {\n  margin-top: 12px;\n  margin-bottom: 2px;\n}\n.conf-modes-options .wrapper[data-v-eda6bfbc]:not(:first-child) {\n  margin-top: 10px;\n}\n.conf-modes-options .wrapper[data-v-eda6bfbc] label.custom-checkbox {\n  margin-bottom: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
